
import { Button, Col, Input, Modal, Row, notification } from 'antd';
import React, { useState, useEffect } from 'react';
import { sendData  } from '../../httpRequests';
import { PlusOutlined, SaveOutlined } from '@ant-design/icons';

const form = {
    secret_key: '',
    pharmacy_name: '',
    email: '',
    add_1: '',
    npi: '',
    zip: '',
    city: '',
    phone: '',
    password: ''
}

export default function CreatePharmacy() {
    const [openModal, setOpenModal] = useState(false)
    const [formValues, setFormValues] = useState(form)

    const {
        secret_key,
        pharmacy_name,
        email,
        add_1,
        npi,
        zip,
        city,
        phone,
        password
    } = formValues

    const open = () => {
        setOpenModal(true)
    }

    const close = () => {
        setOpenModal(false)
    }
    const handleInputChange = ({ target }) => {
        setFormValues({
            ...formValues,
            [target.name]: target.value
        });
    }

    const save = () => {
        const data = { ...formValues }
        const url = '/pharmacies/createNewPharmacy';
        sendData(url, data).then((response) => {
            // console.log(response)
            if(response.ok){
                openNotificationWithIcon("success", response.message)
                setOpenModal(false)
            }else{
                openNotificationWithIcon("warning", response.message)
            }
        })
    }

    const openNotificationWithIcon = (type, mensaje) => {
        notification[type]({
            description: mensaje
        });
    };

    return (
        <div>
            <Button
                htmlType="submit"
                onClick={open}
                type='primary'
                size='large'
                style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}


            >
                <PlusOutlined />
                Create pharmacy
            </Button>
            <Modal title="Create pharmacy"
                visible={openModal}
                onCancel={close}
                width={800}
                footer={null}
                closable={true}
            >

                <Row gutter={24}>
                    <Col span={12} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span>Email</label>
                        <Input
                            type='email'
                            required
                            size='large'
                            name="email"
                            value={email}
                            onChange={handleInputChange}
                        />
                    </Col>
                    <Col span={12} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span>Password</label>
                        <Input
                            type='password'
                            required
                            size='large'
                            name="password"
                            value={password}
                            onChange={handleInputChange}
                        />
                    </Col>
                    <Col span={12} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span>Pharmacy Name</label>
                        <Input
                            type='text'
                            required
                            size='large'
                            name="pharmacy_name"
                            value={pharmacy_name}
                            onChange={handleInputChange}
                        />
                    </Col>
                    <Col span={12} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span>Phone Number</label>
                        <Input
                            type='text'
                            required
                            size='large'
                            name="phone"
                            value={phone}
                            onChange={handleInputChange}
                        />
                    </Col>
                    <Col span={24} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span>Address </label>
                        <Input
                            type='text'
                            required
                            size='large'
                            name="add_1"
                            value={add_1}
                            onChange={handleInputChange}
                        />
                    </Col>
                    <Col span={12}className='formMarginInput' >
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span>City</label>
                        <Input
                            type='text'
                            required
                            size='large'
                            name="city"
                            value={city}
                            onChange={handleInputChange}
                        />
                    </Col>

                    <Col span={12} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span>Zip code</label>
                        <Input
                            type='text'
                            required
                            size='large'
                            name="zip"
                            value={zip}
                            onChange={handleInputChange}
                        />
                    </Col>

                    <Col span={24} style={{ marginTop: '10px' }}>
                        <Button
                            htmlType="submit"
                            onClick={save}
                            type='primary'
                            size='large'
                            style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}
                            disabled={zip == '' || city == '' || add_1 == '' || phone == '' || pharmacy_name == '' || password == '' || email == ''}

                        >
                            <SaveOutlined />
                            Save
                        </Button>
                    </Col>


                </Row>

            </Modal>
        </div>
    )

}